import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Cog6ToothIcon, BoltIcon, GlobeAltIcon } from '@heroicons/react/24/outline'

import Foto_8 from '../../Media/honeywell.png'
import Foto_9 from '../../Media/zebra.png'
import Foto_10 from '../../Media/chainway.png'
import Foto_13 from '../../Media/whcheckin.png'
import Foto_14 from '../../Media/shopping.png'
import Foto_15 from '../../Media/transport.png'
import Foto_16 from '../../Media/rutas.png'
import Foto_17 from '../../Media/picking.png'
import Foto_18 from '../../Media/packing.png'
import Foto_19 from '../../Media/audit2.png'
import Foto_20 from '../../Media/recepcion.png'
import Foto_21 from '../../Media/guia.png'
import Foto_22 from '../../Media/unitech.png'

import RadioWaveRings from '../Elements/RadioWaveRings'
import LocationValueMap from '../Elements/LocationValueMap'
import ItemDetailReveal from '../Elements/ItemDetailReveal'
import CountUpStat from '../Elements/CountUpStat'

const hardwareData = [
  { key: 'honeywell', image: Foto_8, alt: 'honeywell' },
  { key: 'zebra', image: Foto_9, alt: 'zebra' },
  { key: 'chainway', image: Foto_10, alt: 'chainway' },
  { key: 'unitech', image: Foto_22, alt: 'unitech' },
]

const useCasesData = [
  {
    key: 'recepcion',
    image: Foto_13,
  },
  {
    key: 'almacenamiento',
    image: Foto_15,
  },
  {
    key: 'venta',
    image: Foto_14,
  },
]

const solutionOptionsData = [
  { key: 'rutas', image: Foto_16 },
  { key: 'picking', image: Foto_17 },
  { key: 'empaquetado', image: Foto_18 },
  { key: 'auditorias', image: Foto_19 },
  { key: 'guias', image: Foto_21 },
  { key: 'recepcionAcomodo', image: Foto_20 },
]

export default function SolutionsRFID() {
  const { t } = useTranslation('solutionsRfid')

  return (
    <div>
      {/* Hero section */}
      <div className="isolate relative flex flex-col overflow-hidden bg-gradient-to-br from-white via-gray-50 to-electric-50 pt-14 lg:min-h-screen">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[50rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-electric-300 to-neon-200 opacity-40 sm:left-[calc(50%-30rem)] sm:w-[100rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
        <div
          className="pointer-events-none absolute inset-y-0 left-0 -z-10 hidden w-1/2 lg:block"
          style={{
            backgroundImage: 'radial-gradient(circle, rgb(175, 180, 188) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
          aria-hidden="true"
        />
        <div className="flex flex-1 items-center py-10 sm:py-12 md:py-14 lg:py-16">
          <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-2 lg:px-8">
            <div className="relative order-1 hidden lg:block">
              <div
                className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 blur-sm sm:-bottom-28 sm:-left-20 sm:h-80 sm:w-80"
                aria-hidden="true"
              >
                <RadioWaveRings
                  className="absolute inset-0"
                  ringColorClasses={['border-electric-500/50', 'border-electric-500/30', 'border-electric-500/15']}
                />
              </div>
              <div className="relative z-10 overflow-hidden rounded-2xl ">
                <LocationValueMap className="h-72" />
              </div>
            </div>
            <div className="order-2">
              <span className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-1.5 text-sm font-medium text-electric-700 shadow-sm">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-electric-400 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-electric-600"></span>
                </span>
                {t('hero.badge')}
              </span>
              <h1 className="mt-6 text-4xl font-bold tracking-tight text-navy-900 sm:text-5xl">
                {t('hero.heading.prefix')}<span className="text-electric-600">{t('hero.heading.highlight')}</span>
              </h1>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                {t('hero.description')}
              </p>
              <div className="mt-10 flex flex-row flex-wrap items-start gap-3 sm:gap-4">
                <Link
                  to="/contact"
                  state="demo-rfid"
                  className="rounded-md bg-navy-900 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-navy-800 sm:px-5 sm:py-3 sm:text-base"
                >
                  {t('hero.ctaPrimary')} <span aria-hidden="true">&rarr;</span>
                </Link>
                <Link
                  to={{ pathname: '/', hash: '#casos-de-exito' }}
                  className="rounded-md border border-gray-300 px-4 py-2.5 text-sm font-semibold text-navy-900 transition hover:bg-gray-50 sm:px-5 sm:py-3 sm:text-base"
                >
                  {t('hero.ctaSecondary')}
                </Link>
              </div>
              <dl className="mt-12 grid grid-cols-3 gap-6 border-t border-gray-200 pt-8">
                <CountUpStat
                  target={99.9}
                  decimals={1}
                  suffix="%"
                  label={t('hero.stats.precision')}
                  valueClassName="text-2xl font-bold text-electric-600 sm:text-3xl"
                  labelClassName="mt-1 text-xs text-gray-500 sm:text-sm"
                />
                <CountUpStat
                  target={50}
                  prefix="<"
                  suffix="ms"
                  label={t('hero.stats.response')}
                  valueClassName="text-2xl font-bold text-electric-600 sm:text-3xl"
                  labelClassName="mt-1 text-xs text-gray-500 sm:text-sm"
                />
                <CountUpStat
                  target={100}
                  suffix="%"
                  label={t('hero.stats.traceability')}
                  valueClassName="text-2xl font-bold text-electric-600 sm:text-3xl"
                  labelClassName="mt-1 text-xs text-gray-500 sm:text-sm"
                />
              </dl>
            </div>
          </div>
        </div>

        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-50rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-electric-200 to-neon-200 opacity-40 sm:left-[calc(50%+36rem)] sm:w-[100rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
      </div>

      {/* SOLUCIONES MODULARES */}
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:pt-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-base font-semibold leading-7 text-electric-600">{t('modulares.eyebrow')}</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {t('modulares.heading')}
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            {t('modulares.description')}
          </p>
        </div>
      </div>

      {/* VISIONTAG ENGINE */}
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:pt-32 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div className="overflow-hidden rounded-2xl border border-gray-200">
            <ItemDetailReveal className="h-72" />
          </div>
          <div>
            <h2 className="text-base font-semibold leading-7 text-electric-600">{t('engine.eyebrow')}</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              {t('engine.heading')}
            </p>
            <div className="mt-8 space-y-8">
              <div>
                <Cog6ToothIcon className="h-6 w-6 text-electric-600" aria-hidden="true" />
                <h3 className="mt-3 text-sm font-bold text-navy-900">
                  {t('engine.features.erp.title')}
                </h3>
                <p className="mt-1 text-sm leading-6 text-gray-600">
                  {t('engine.features.erp.description')}
                </p>
              </div>
              <div>
                <BoltIcon className="h-6 w-6 text-electric-600" aria-hidden="true" />
                <h3 className="mt-3 text-sm font-bold text-navy-900">
                  {t('engine.features.integral.title')}
                </h3>
                <p className="mt-1 text-sm leading-6 text-gray-600">
                  {t('engine.features.integral.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* COMPATIBILIDAD TOTAL */}
      <div className="relative isolate mt-24 overflow-hidden bg-navy-950 sm:mt-32">
        <div
          className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-tr from-electric-500/30 to-neon-300/20 blur-3xl"
          aria-hidden="true"
        />
        <div className="mx-auto max-w-3xl px-6 py-16 text-center lg:px-8">
          <h2 className="text-base font-semibold leading-7 text-neon-300">{t('compatibilidad.eyebrow')}</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {t('compatibilidad.heading')}
          </p>
          <p className="mt-6 text-lg leading-8 text-white/70">
            {t('compatibilidad.description')}
          </p>
        </div>
      </div>

      {/* IMPLEMENTACIÓN Y SOPORTE (SLA) */}
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:pt-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-base font-semibold leading-7 text-electric-600">{t('soporte.eyebrow')}</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {t('soporte.heading')}
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            {t('soporte.description')}
          </p>
        </div>
        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <span className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-4 py-1.5 text-sm font-medium text-gray-700">
            <GlobeAltIcon className="h-4 w-4 text-electric-600" aria-hidden="true" />
            {t('soporte.languagesBadge')}
          </span>
        </div>
      </div>

      {/* COMPATIBILIDAD RFID TOTAL */}
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:pt-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-base font-semibold leading-7 text-electric-600">{t('rfidTotal.eyebrow')}</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {t('rfidTotal.heading')}
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            {t('rfidTotal.description')}
          </p>
        </div>
        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-6 lg:max-w-none lg:grid-cols-4">
          {hardwareData.map((hw) => (
            <div
              key={hw.key}
              className="flex flex-col items-center gap-3 rounded-xl border border-gray-200 p-5 text-center transition-all duration-200 hover:-translate-y-1 hover:border-electric-200 hover:shadow-md"
            >
              <img src={hw.image} alt={hw.alt} className="h-12 w-auto object-contain" />
              <p className="text-xs leading-5 text-gray-600">{t(`rfidTotal.hardware.${hw.key}.description`)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CÓMO LO HACEMOS */}
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:pt-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-base font-semibold leading-7 text-electric-600">{t('comoLoHacemos.eyebrow')}</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {t('comoLoHacemos.heading')}
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            {t('comoLoHacemos.description')}
          </p>
        </div>
        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
          {useCasesData.map((useCase) => (
            <Link
              key={useCase.key}
              // to="/contact"
              state="demo-rfid"
              className="group flex flex-col overflow-hidden rounded-2xl border border-gray-200"
            >
              <div className="overflow-hidden">
                <img
                  src={useCase.image}
                  alt={t(`comoLoHacemos.useCases.${useCase.key}.alt`)}
                  className="h-40 w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="text-xl font-bold text-navy-900">{t(`comoLoHacemos.useCases.${useCase.key}.title`)}</h3>
                <p className="mt-3 flex-auto text-sm leading-6 text-gray-600">{t(`comoLoHacemos.useCases.${useCase.key}.description`)}</p>
                
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* PON EN MARCHA TUS OPERACIONES */}
      <div className="mx-auto max-w-7xl px-6 pt-24 sm:pt-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-base font-semibold leading-7 text-electric-600">{t('operacionDiaria.eyebrow')}</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {t('operacionDiaria.heading')}
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            {t('operacionDiaria.description')}
          </p>
        </div>
        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-3 lg:max-w-none">
          {solutionOptionsData.map((option) => (
            <div
              key={option.key}
              className="flex flex-col items-center gap-2 rounded-xl border border-gray-200 p-5 text-center transition-all duration-200 hover:-translate-y-1 hover:border-electric-200 hover:shadow-md"
            >
              <img src={option.image} alt={t(`operacionDiaria.options.${option.key}`)} className="h-10 w-auto object-contain" />
              <span className="text-sm font-bold text-navy-900">{t(`operacionDiaria.options.${option.key}`)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* CIERRE */}
      <div className="mx-auto max-w-7xl px-6 pt-24 pb-24 sm:pt-32 sm:pb-32 lg:px-8">
        <div className="relative isolate overflow-hidden rounded-3xl bg-gradient-to-br from-white via-gray-50 to-electric-50 shadow-xl">
          <div
            className="pointer-events-none absolute -right-24 -top-24 -z-10 h-72 w-72 rounded-full bg-gradient-to-tr from-electric-300 to-neon-200 opacity-40 blur-3xl"
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute inset-y-0 left-0 -z-10 hidden w-1/2 lg:block"
            style={{
              backgroundImage: 'radial-gradient(circle, rgb(175, 180, 188) 1px, transparent 1px)',
              backgroundSize: '28px 28px',
            }}
            aria-hidden="true"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative flex flex-col justify-center px-6 py-16 sm:px-12 sm:py-20 lg:px-16">
              <span className="inline-flex w-fit items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-1.5 text-sm font-medium text-electric-700 shadow-sm">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-electric-400 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-electric-600"></span>
                </span>
                {t('cierre.badge')}
              </span>
              <p className="mt-6 text-3xl font-bold tracking-tight text-navy-900 sm:text-4xl">
                {t('cierre.heading')}
              </p>
              <p className="mt-6 max-w-md text-lg leading-8 text-gray-600">
                {t('cierre.description')}
              </p>
              <div className="mt-10">
                <Link
                  to="/contact"
                  state="demo-rfid"
                  className="flex w-full items-center justify-center rounded-md bg-navy-900 px-6 py-3.5 text-base font-semibold text-white shadow-sm transition hover:bg-navy-800 lg:inline-flex lg:w-auto"
                >
                  {t('cierre.ctaLabel')} <span aria-hidden="true" className="ml-1">&rarr;</span>
                </Link>
              </div>
            </div>

            <div className="relative hidden min-h-[22rem] items-center justify-center px-6 py-12 lg:flex lg:min-h-0 lg:px-12">
              <div
                className="pointer-events-none absolute -bottom-16 -right-10 h-64 w-64 blur-sm"
                aria-hidden="true"
              >
                <RadioWaveRings
                  className="absolute inset-0"
                  ringColorClasses={['border-electric-500/50', 'border-electric-500/30', 'border-electric-500/15']}
                />
              </div>
              <div className="relative z-10 w-full max-w-sm overflow-hidden rounded-xl border border-white/10 bg-navy-950 shadow-2xl">
                <div className="flex items-center gap-1.5 border-b border-white/10 bg-white/5 px-4 py-3">
                  <span className="h-3 w-3 rounded-full bg-white/20"></span>
                  <span className="h-3 w-3 rounded-full bg-white/20"></span>
                  <span className="h-3 w-3 rounded-full bg-white/20"></span>
                  <span className="ml-2 text-xs text-white/40">{t('cierre.terminal.header')}</span>
                </div>
                <div className="space-y-1.5 p-5 font-mono text-xs leading-relaxed sm:text-sm">
                  <p><span className="text-neon-300">$</span> <span className="text-white/80">{t('cierre.terminal.command')}</span></p>
                  {t('cierre.terminal.readings', { returnObjects: true }).map((line) => (
                    <p key={line} className="text-white/40">{line}</p>
                  ))}
                  <p className="text-electric-300">&#10003; {t('cierre.terminal.synced')}</p>
                  <p className="flex items-center gap-1 text-white/40">
                    {t('cierre.terminal.ready')}
                    <span className="inline-block h-3.5 w-1.5 animate-pulse bg-neon-300"></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
